import PropTypes from "prop-types";
import { Tooltip } from "antd";
import { PillRoot } from "./ConfidencePillStyled";
import { getConfidenceTone } from "../../theme/tokens";

/**
 * Displays the AI's confidence in a document's category as a colored pill.
 *
 * `value` is a 0..1 number (the backend's `ai_confidence` field). When the
 * value is missing/null/NaN the pill renders nothing, so callers can safely
 * drop this into a table without worrying about partial data.
 *
 * Thresholds live in {@link theme/tokens.CONFIDENCE_THRESHOLDS}; the band
 * (high / medium / low) is resolved via `getConfidenceTone`.
 */
const ConfidencePill = ({ value, size = "sm", className }) => {
  if (value == null || Number.isNaN(Number(value))) return null;

  const numeric = Number(value);
  const tone = getConfidenceTone(numeric);
  if (!tone) return null;

  const pct = Math.round(numeric * 100);

  const title = {
    high: "High confidence — trust the category",
    medium: "Medium confidence — worth a glance",
    low: "Low confidence — please review",
  }[tone];

  return (
    <Tooltip title={title} placement="top">
      <PillRoot $tone={tone} $size={size} className={className}>
        {pct}%
      </PillRoot>
    </Tooltip>
  );
};

ConfidencePill.propTypes = {
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  size: PropTypes.oneOf(["sm", "md"]),
  className: PropTypes.string,
};

export default ConfidencePill;
